module.exports = __webpack_public_path__ + "static/media/m4.6ec8059b.png";